import React from 'react';

export default class TransactionCouponIcon extends React.Component {
  render() {
    return (
      <svg height="100%" viewBox="0 0 30.227 19.263">
      <g>
        <path fill="#6FCBE9" d="M30.227,5.82V0h-5.67v0.995h-1.327V0H0v5.82c2.105,0,3.811,1.706,3.811,3.811
          c0,2.105-1.706,3.811-3.811,3.811v5.82h30.227v-5.82c-2.105,0-3.811-1.706-3.811-3.811C26.415,7.526,28.122,5.82,30.227,5.82z
           M17.021,13.833H9.945c-2.317,0-4.202-1.885-4.202-4.202s1.885-4.202,4.202-4.202h7.077c2.317,0,4.202,1.885,4.202,4.202
          S19.338,13.833,17.021,13.833z M24.556,19.262h-1.327v-0.995h1.327V19.262z M24.556,16.348h-1.327v-1.919h1.327V16.348z
           M24.556,12.51h-1.327v-1.919h1.327V12.51z M24.556,8.672h-1.327V6.752h1.327V8.672z M24.556,4.833h-1.327V2.914h1.327V4.833z"/>
        <path fill="#6FCBE9" d="M17.021,6.756H9.945c-1.585,0-2.875,1.29-2.875,2.875c0,1.585,1.29,2.875,2.875,2.875h7.077
          c1.585,0,2.875-1.29,2.875-2.875C19.897,8.046,18.607,6.756,17.021,6.756z"/>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      </svg>  
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/icons/TransactionCouponIcon.js